import { createPersistedState } from 'pinia-plugin-persistedstate';

const plugins = {
	persistedState: createPersistedState({
		storage: localStorage,
	}),
};

export const setPiniaPlugins = (piniaInstance) => {
	for (const plugin of Object.values(plugins)) {
		piniaInstance.use(plugin);
	}
};
